<template>
  <div id="nav_box" class="top_nav paddY">
    <div class="relativeItem">
      <div class="iconLeft absoluteItem" @click="goback">
        <img class="imgBlock noevents-img" src="../../assets/iconback.png" />
      </div>
      <div>{{ title }}</div>
    </div>
  </div>
</template>










<script>
export default {
  name: "top_nav",
  props: ["title"],
  data() {
    return {
      // padding_top: 20, //导航顶部padding
      padHeight: 0,
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },

    setTopPad() {
      document.querySelector(".top_nav").style.paddingTop =
        this.padHeight + 16 + "px";
    },
  },
  mounted: function () {
    if (this.$tool.isAorI() != "Android") {
      this.padHeight = this.$appAc.get_top_bar_height();
      this.setTopPad();
    }
  },
};
</script>














<style scoped>
.top_nav {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  background-color: #fff;
  padding: 30px 0 12px;
  text-align: center;
  font-size: 1rem;
  color: #000;
  font-weight: bold;
}
.iconLeft {
  left: 0;
  bottom: -15px;
  width: 50px;
  height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
}
.iconLeft img {
  width: 50%;
  margin: auto;
}
@media only screen and (width: 375px) and (height: 690px) {
  .paddY {
    padding-top: 60px !important;
  }
}
/*iPhone6和iPhone8*/
@media only screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) {
  .paddY {
    padding-top: 35px !important;
  }
}
</style>

